import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

export function createDisplayProductScreenIntent(urlKey: string): WebViewIntent {
  return createIntent('DISPLAY_PRODUCT_SCREEN', {
    urlKey,
  })
}

export function createOpenDiscriminantFiltersDrawerIntent(): WebViewIntent {
  return createIntent('OPEN_DISCRIMINANT_FILTERS_DRAWER')
}

export function createApplyDiscriminantFiltersDrawerIntent(
  filters?: Record<string, string>,
): WebViewIntent {
  return createIntent('APPLY_DISCRIMINANT_FILTERS_DRAWER', {
    filters: JSON.stringify(filters || {}),
  })
}

export function createProductAddedToCartIntent(): WebViewIntent {
  return createIntent('PRODUCT_ADDED_TO_CART')
}
